import {testIdProps} from '@github-ui/test-id-props'
import {useNamedColor} from '@github-ui/use-named-color'
import {ProgressBar} from '@primer/react'
import {clsx} from 'clsx'

import styles from './progress-bar.module.css'
import type {ProgressBarCustomProps} from './types'

export const ProgressBarSolid = ({
  color,
  completed,
  consistentContentSizing,
  hideNumerals,
  name,
  percentCompleted,
  total,
  ...progressBarProps
}: ProgressBarCustomProps) => {
  const {accent} = useNamedColor(color)

  const containerClasses = clsx(styles.containerSolid, {
    [`${styles.consistentContentSizing}`]: consistentContentSizing,
  })

  const completeClasses = clsx(styles.barItemComplete, {
    [styles.fullProgress]: percentCompleted === 100,
  })

  const incompleteClasses = clsx(styles.barItemIncomplete, {
    [styles.fullProgress]: percentCompleted === 0,
  })

  return (
    <div className={containerClasses} {...testIdProps('progress-bar-solid')}>
      {!hideNumerals && (
        <span className={styles.textCount}>
          {completed} / {total}
        </span>
      )}

      <ProgressBar className={styles.solid} inline {...progressBarProps}>
        <ProgressBar.Item
          // Adding aria-hidden since the percent span conveys the information
          aria-hidden
          progress={percentCompleted}
          className={completeClasses}
          style={{backgroundColor: accent}}
        />
        <ProgressBar.Item
          // Adding aria-hidden since the percent span conveys the information
          aria-hidden
          progress={100 - percentCompleted}
          className={incompleteClasses}
          style={{backgroundColor: accent}}
        />
      </ProgressBar>

      {!hideNumerals && <span className={styles.textPercentage}>{percentCompleted}%</span>}
    </div>
  )
}
